(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["studio-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const enabled = () => document.body.dataset.studioMotion === 'true' && !preference.matches;
  const seen = new WeakSet();
  const pending = new Set();
  const active = new Set();
  const selector = '.studio-heading-row,.studio-card,.studio-editorial-copy,.studio-editorial-image,.studio-detail-grid article,.studio-compare-grid article,.studio-faq-grid>div,.studio-newsletter,.studio-banner>.studio-wrap,.studio-story-intro';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let index = 0;
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      pending.delete(entry.target);
      if (!enabled() || !entry.target.isConnected) continue;
      const animation = entry.target.animate([
        { opacity: .2, transform: 'translateY(20px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 800, delay: Math.min(index++ * 70, 140), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      active.add(animation);
      animation.onfinish = animation.oncancel = () => active.delete(animation);
    }
  }, { threshold: .08 }) : null;
  const setup = (root = document) => {
    if (!observer || !enabled() || !Element.prototype.animate) return;
    root.querySelectorAll(selector).forEach(element => {
      if (seen.has(element) || element.parentElement.closest(selector)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      pending.add(element);
      observer.observe(element);
    });
  };
  const stop = () => {
    if (enabled()) { setup(); return; }
    if (observer) observer.disconnect();
    pending.clear();
    active.forEach(animation => animation.cancel());
    active.clear();
  };
  preference.addEventListener('change', stop);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    pending.forEach(element => {
      if (!event.target.contains(element)) return;
      observer.unobserve(element);
      pending.delete(element);
    });
    active.forEach(animation => {
      if (event.target.contains(animation.effect.target)) animation.cancel();
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.studio-mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.studio-mobile-menu[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
})();
  } catch(e) { console.error(e); }
})();

})();
